<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Gamepad" class="d-icon d-icon--gamepad" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M4 4a.5.5 0 0 1 .5.5V5H5a.5.5 0 1 1 0 1h-.5v.5a.5.5 0 1 1-1 0V6H3a.5.5 0 0 1 0-1h.5v-.5A.5.5 0 0 1 4 4Zm4.5 1a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H9a.5.5 0 0 1-.5-.5ZM7 6a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H7.5A.5.5 0 0 1 7 6Z"/><path d="M7.043 8.499A.505.505 0 0 1 7 8.5H4.914a.5.5 0 0 0-.353.147l-.72.72c-.255.255-.633.633-1.34.633a2 2 0 0 1-2-2c0-.809.306-3.362.345-3.686l.001-.01a.404.404 0 0 0 .003-.022l.004-.041a2.5 2.5 0 0 1 2.486-2.24H8.5c.027 0 .054.002.08.006A.504.504 0 0 1 8.66 2a2.5 2.5 0 0 1 2.49 2.283l.003.019.001.01v.002c.04.327.346 2.877.346 3.686a2 2 0 0 1-2 2c-.707 0-1.085-.378-1.34-.633l-.72-.72a.5.5 0 0 0-.354-.147h-.043ZM8.58 2.994A.503.503 0 0 1 8.5 3H3.34a1.5 1.5 0 0 0-1.49 1.347l-.001.006v.002a3.71 3.71 0 0 1-.01.079C1.796 4.803 1.5 7.269 1.5 8a1 1 0 0 0 1 1c.28 0 .402-.108.647-.353l.707-.707a1.5 1.5 0 0 1 1.06-.44H7l.043.002a1.5 1.5 0 0 1 1.104.438l.707.707c.245.245.366.353.646.353a1 1 0 0 0 1-1c0-.73-.293-3.193-.338-3.565a1.664 1.664 0 0 1-.006-.05l-.003-.03-.001-.008A1.5 1.5 0 0 0 8.66 3a.504.504 0 0 1-.08-.006Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconGamepad',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
